import React, { Component } from 'react';
import StandardButton from './StandardButton';
import PropTypes from 'prop-types';

/**
 * @props {string} display
 * @props {function} onClick - required
 * @returns StandardButton
 */
class CancelButton extends Component {
	render() { 
		const { onClick, display, classNameAdd } = this.props;
		return <StandardButton 
			onClick = { onClick } 
			classNameAdd = {'pt-button pt-fixed pt-icon-small-cross ' + classNameAdd}
		>
			{display}
		</StandardButton>;
	}
}

CancelButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	display: PropTypes.string,
	classNameAdd: PropTypes.string
}

CancelButton.defaultProps = {
	display: 'Cancel',
	classNameAdd: ''
}

export default CancelButton;




// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/CancelButton.jsx